export enum TaskDtoKeysEnum {
  /** BRS tasks widget API response body */
  BRS_TASKS_WIDGET_FIND_DTO = 'dashboard/brs-tasks-widget-find.dto',
  /** BRS tasks widget API query parameters */
  BRS_TASKS_WIDGET_QUERY_DTO = 'dashboard/brs-tasks-widget-query.dto',

  PLANNED_INCOME_HISTORY_FIND_DTO = 'task/planned-income-history-find.dto',
  PLANNED_INCOME_HISTORY_PAGE_DTO = 'task/planned-income-history-page.dto',
  /** Planned income bind documents API request body */
  PLANNED_INCOME_BIND_DOCUMENTS_DTO = 'task/planned-income-bind-documents.dto',
  /** Planned income list API filters */
  PLANNED_INCOME_FILTERS_DTO = 'task/planned-income-filters.dto',
  /** Planned income find one API query parameters (API additiona options) */
  PLANNED_INCOME_FIND_ONE_QUERY_DTO = 'task/planned-income-find-one-query.dto',
  /** Planned income response body */
  PLANNED_INCOME_FIND_DTO = 'task/planned-income-find.dto',
  /** Planned income list API response body */
  PLANNED_INCOME_PAGE_DTO = 'task/planned-income-page.dto',
  /** Planned income list API query parameters */
  PLANNED_INCOME_QUERY_DTO = 'task/planned-income-query.dto',
  /** Planned income create/update APIs request body */
  PLANNED_INCOME_FORM_DTO = 'task/planned-income-form.dto',
  /** Planned income partial update API request body */
  PLANNED_INCOME_PARTIAL_FORM_DTO = 'task/planned-income-partial-form.dto',
  /** Planned income subtotal API response body item */
  PLANNED_INCOME_SUBTOTAL_FIND_DTO = 'task/planned-income-subtotal-find.dto',
  /** Planned income subtotal API query parameters */
  PLANNED_INCOME_SUBTOTAL_QUERY_DTO = 'task/planned-income-subtotal-query.dto',
  /** Planned income total amount API response body */
  PLANNED_INCOME_TOTAL_AMOUNT_FIND_DTO = 'task/planned-income-total-amount-find.dto',
  /** Planned income total amount API query parameters */
  PLANNED_INCOME_TOTAL_AMOUNT_QUERY_DTO = 'task/planned-income-total-amount-query.dto',
  /** Payment calendar actual date API response body */
  PAYMENT_CALENDAR_ACTUAL_DATE = 'task/payment-calendar-actual-date',
  /** Payment calendar API query parameters */
  PAYMENT_CALENDAR_QUERY_DTO = 'task/payment-calendar-query.dto',

  PAYMENT_CALENDAR_REPORT_FIND_DTO = 'task/payment-calendar-report-find.dto',
  PAYMENT_CALENDAR_HEADER_COLUMN_DTO = 'task/payment-calendar-header-column.dto',
  /** Payment calendar column response body */
  PAYMENT_CALENDAR_COLUMN_DTO = 'task/payment-calendar-column.dto',
  /** Expired BRS tasks statistics for payment calendar */
  PAYMENT_CALENDAR_EXPIRED_BRS_TASKS_DTO = 'task/payment-calendar-expired-brs-tasks.dto',
  PAYMENT_CALENDAR_ROW_DTO = 'task/payment-calendar-row.dto',
  /** JSON form for bulk creation of planned expensese (BRS tasks) for concrete direction and period */
  PAYMENT_CALENDAR_PLANNED_EXPENSE_FORM_DTO = 'task/payment-calendar-planned-expense-form.dto',
  /** JSON form for bulk creation of planned income (BRS tasks) for concrete direction and period */
  PAYMENT_CALENDAR_PLANNED_INCOME_FORM_DTO = 'task/payment-calendar-planned-income-form.dto',
  /** Task page group data response body */
  TASKS_PAGE_GROUP_DATA_DTO = 'task/tasks-page-group-data.dto',
  /** BRS tasks page response body */
  TASKS_PAGE_DTO = 'task/tasks-page.dto',
  BUDGET_REQUEST_FACT_ANALYTICS_ITEM_DTO = 'task/budget-request-fact-analytics-item.dto',
  BUDGET_REQUEST_FACT_ANALYTICS_QUERY_DTO = 'task/budget-request-fact-analytics-query.dto',
  /** Budget request items prefab API query parameters */
  BUDGET_REQUEST_ITEM_PREFAB_QUERY_DTO = 'task/budget-request-items-prefab-query.dto',
  /** Analytics for the previous three months for the budget request item */
  BUDGET_REQUEST_ITEM_ANALYTICS_DTO = 'task/budget-request-item-analytics.dto',
  /** Budget request item bulk update request body */
  BUDGET_REQUEST_ITEM_BULK_FORM_DTO = 'task/budget-request-item-bulk-form.dto',
  /** Budget request item response body */
  BUDGET_REQUEST_ITEM_FIND_DTO = 'task/budget-request-item-find.dto',
  /** Budget request item create/update request body */
  BUDGET_REQUEST_ITEM_FORM_DTO = 'task/budget-request-item-form.dto',
  /** Budget request create/update request body */
  BUDGET_REQUEST_FORM_DTO = 'task/budget-request-form.dto',
  /** Budget request create/update request body */
  BUDGET_REQUEST_CREATE_FORM_DTO = 'task/budget-request-create-form.dto',
  /** Budget request partial update request body */
  BUDGET_REQUEST_PARTIAL_FORM_DTO = 'task/budget-request-partial-form.dto',
  /** Budget request query params */
  BUDGET_REQUEST_QUERY_DTO = 'task/budget-request-query.dto',
  /** Budget request status switch parameters */
  BUDGET_REQUEST_STATUS_SWITCH_DTO = 'task/budget-request-status-switch.dto',
  /** Budget request approver - approval scheme participant with approvement status (not editable, response body only) */
  BUDGET_REQUEST_APPROVER_FIND_DTO = 'task/budget-request-approver-find.dto',
  /** Budget request related projects update API request body */
  BUDGET_REQUEST_PROJECT_FORM_DTO = 'task/budget-request-project-form.dto',
  /** Budget request related projects query params */
  BUDGET_REQUEST_PROJECT_QUERY_DTO = 'task/budget-request-project-query.dto',
  /** Budget request history entry (response body) */
  BUDGET_REQUEST_HISTORY_FIND_DTO = 'task/budget-request-history-find.dto',
  /** Budget request history page (response body) */
  BUDGET_REQUEST_HISTORY_PAGE_DTO = 'task/budget-request-history-page.dto',
  /** Budget request attached files JSON "page" */
  BUDGET_REQUEST_FILES_PAGE_DTO = 'task/budget-request-files-page.dto',
  /** Budget request files attachment parameters (request body) */
  BUDGET_REQUEST_FILES_FORM_DTO = 'task/budget-request-files-form.dto',
  /** Budget request file "one-to-one" query APIs URL parameters */
  BUDGET_REQUEST_FILE_QUERY_DTO = 'task/budget-request-file-query.dto',
  /** Budget request approvement "one-to-one" APIs URL parameters */
  BUDGET_REQUEST_APPROVEMENT_QUERY_DTO = 'task/budget-request-approvement-query.dto',
  /** Budget request response body */
  BUDGET_REQUEST_FIND_DTO = 'task/budget-request-find.dto',
  /** Task analytics API column descriptor response body */
  TASK_ANALYTICS_COLUMN_DTO = 'task/task-analytics-column.dto',
  /** Task analytics API query parameters */
  TASK_ANALYTICS_QUERY_DTO = 'task/task-analytics-query.dto',
  /** Task analytics API row response body */
  TASK_ANALYTICS_ROW_DTO = 'task/task-analytics-row.dto',
  /** Task analytics API response body */
  TASK_ANALYTICS_DTO = 'task/task-analytics.dto',
  /** BRS task counterparty's bank details form */
  TASK_CONTRAGENT_BANK_DETAILS_FORM_DTO = 'task/task-contragent-bank-details-form.dto',
  /** BRS task counterparty (recipient of payment) form */
  TASK_CONTRAGENT_FORM_DTO = 'task/task-contragent-form.dto',
  /** BRS task find response body */
  TASK_FIND_DTO = 'task/task-find.dto',
  /** BRS task create or update request body */
  TASK_FORM_DTO = 'task/task-form.dto',
  /** BRS task partial update request body */
  TASK_PARTIAL_UPDATE_FORM_DTO = 'task/task-partial-update-form.dto',
  /** BRS task file response body */
  TASK_FILE_FIND_DTO = 'task/task-file-find.dto',
  /** BRS tasks base filters */
  TASK_FILTERS_DTO = 'task/task-filters.dto',
  /** BRS task find one API query parameters (additional options) */
  TASK_FIND_ONE_QUERY_DTO = 'task/task-find-one-query.dto',
  /** BRS tasks list API query parameters */
  TASK_FIND_QUERY_DTO = 'task/task-find-query.dto',
  /** BRS tasks priority find response body */
  TASKS_PRIORITY_FIND_DTO = 'task/tasks-priority-find.dto',
  /** Task status swithc API request body */
  TASK_SET_STATUS_DTO = 'task/task-set-status.dto',
  /** BRS task move payment date API request body */
  TASK_MOVE_PAYMENT_DATE_DTO = 'task/task-move-payment-date.dto',
  /** Multiple move payment date for BRS tasks API request body */
  TASK_MULTIPLE_MOVE_PAYMENT_DATE_DTO = 'task/task-multiple-move-payment-date.dto',
  /** BRS tasks status find response body */
  TASKS_STATUS_FIND_DTO = 'task/tasks-status-find.dto',
  /** BRS task status create/update request body */
  TASK_STATUS_FORM_DTO = 'task/task-status-form.dto',
  /** BRS tasks status transition find response body */
  TASKS_STATUS_TRANSITION_FIND_DTO = 'task/tasks-status-transition-find.dto',
  /** BRS tasks status form settings item find response body */
  TASKS_STATUS_FORM_SETTINGS_ITEM_FIND_DTO = 'task/tasks-status-form-settings-item-find.dto',
  /** BRS tasks status form settings find response body */
  TASKS_STATUS_FORM_SETTINGS_FIND_DTO = 'task/tasks-status-form-settings-find.dto',
  /** BRS task order find response body */
  TASK_ORDER_FIND_DTO = 'task/tasks-order-find.dto',
  /** BRS task order create and update form */
  TASK_ORDER_FORM_DTO = 'task/task-order-form.dto',
  /** BRS tasks approver find response body */
  TASKS_APPROVER_FIND_DTO = 'task/tasks-approver-find.dto',
  /** Task approver request URL parameters */
  TASKS_APPROVER_URL_PARAMS_DTO = 'task/tasks-approver-url-params.dto',
  /** Response for tenant common task auditors or approvers */
  TASKS_TENANT_AUDITORS_FIND_DTO = 'task/tasks-tenant-auditors-find.dto',
  /** Tenant common task auditors or approvers update request body */
  TASKS_TENANT_AUDITORS_UPDATE_DTO = 'task/tasks-tenant-auditors-update.dto',
  /** Task template base filters */
  TASK_TEMPLATE_FILTERS_DTO = 'task/task-template-filters.dto',
  /** Task template find one API additional query parameters */
  TASK_TEMPLATE_FIND_ONE_QUERY_DTO = 'task/task-template-find-one-query.dto',
  /** Task template response body */
  TASK_TEMPLATE_FIND_DTO = 'task/task-template-find.dto',
  /** Task template creation request body */
  TASK_TEMPLATE_FORM_DTO = 'task/task-template-form.dto',
  /** Task templates list API response body */
  TASK_TEMPLATE_PAGE_DTO = 'task/task-template-page.dto',
  /** BRS task template search querystring parameters */
  TASK_TEMPLATE_QUERY_DTO = 'task/task-template-query.dto',
  /** Task template history response body */
  TASK_TEMPLATE_HISTORY_FIND_DTO = 'task/task-template-history-find.dto',
  /** Task template history page response body */
  TASK_TEMPLATE_HISTORY_PAGE_DTO = 'task/task-template-history-page.dto',
  /** Task request history entry (response body) */
  TASK_HISTORY_FIND_DTO = 'task/history-find.dto',
  /** Task refuse by approver request body */
  TASK_REFUSE_FORM_DTO = 'task/refuse-form.dto',
  /** Expense dynamics report item (plot point) */
  TASK_EXPENSE_DYNAMICS_ITEM_FIND_DTO = 'task/expense-dynamics-item-find.dto',
  /** Task expense dynamics report response body */
  TASK_EXPENSE_DYNAMICS_REPORT_FIND_DTO = 'task/expense-dynamics-report-find.dto',
  /** BRS task expense dynamics report query parameters */
  TASK_EXPENSE_DYNAMICS_QUERY_DTO = 'task/expense-dynamics-report-query.dto',
  /** Result of concrete task exporting to 1C ERP database */
  EXPORT_ORDER_1C_FIND_DTO = 'task/export-order-1c-find.dto',
  /** Result of single BRS task exporting to 1C ERP databases */
  EXPORT_ONE_TO_1C_FIND_DTO = 'task/export-one-to-1c-find.dto',
  /** Payment scenarion list APIs base filters */
  PAYMENT_SCENARION_FILTERS_DTO = 'task/payment-scenarion-filters.dto',
  /** Payment scenarion find one API query parameters */
  PAYMENT_SCENARION_FIND_ONE_QUERY_DTO = 'task/payment-scenarion-find-one-query.dto',
  /** Payment scenarion response body */
  PAYMENT_SCENARION_FIND_DTO = 'task/payment-scenarion-find.dto',
  /** Payment scenarion request body */
  PAYMENT_SCENARION_FORM_DTO = 'task/payment-scenarion-form.dto',
  /** Payment scenarion list response body */
  PAYMENT_SCENARION_PAGE_DTO = 'task/payment-scenarion-page.dto',
  /** Payment scenarion query params */
  PAYMENT_SCENARION_QUERY_DTO = 'task/payment-scenarion-query.dto',
  /** Payment scenarion partial request body */
  PAYMENT_SCENARION_PARTIAL_FORM_DTO = 'task/payment-scenarion-partial-form.dto',
  /** Payment scenarion condition response body */
  PAYMENT_SCENARION_CONDITION_FIND_DTO = 'task/payment-scenarion-condition-find.dto',
  /** Payment scenarion condition request body */
  PAYMENT_SCENARION_CONDITION_FORM_DTO = 'task/payment-scenarion-condition-form.dto',
  /** Payment scenarion condition list response body */
  PAYMENT_SCENARION_CONDITION_PAGE_DTO = 'task/payment-scenarion-condition-page.dto',
  /** Payment scenarion condition partial request body */
  PAYMENT_SCENARION_CONDITION_PARTIAL_FORM_DTO = 'task/payment-scenarion-condition-partial-form.dto',
  /** Payment scenarion condition query params */
  PAYMENT_SCENARION_CONDITION_QUERY_DTO = 'task/payment-scenarion-condition-query.dto',
  /** Payment scenarion action response body */
  PAYMENT_SCENARION_ACTION_FIND_DTO = 'task/payment-scenarion-action-find.dto',
  /** Payment scenarion action request body */
  PAYMENT_SCENARION_ACTION_FORM_DTO = 'task/payment-scenarion-action-form.dto',
  /** Payment scenarion action partial request body */
  PAYMENT_SCENARION_ACTION_PARTIAL_FORM_DTO = 'task/payment-scenarion-action-partial-form.dto',
  /** Payment scenarion action query params */
  PAYMENT_SCENARION_ACTION_QUERY_DTO = 'task/payment-scenarion-action-query.dto',
  /** Payment scenarion action approver request body */
  PAYMENT_SCENARION_ACTION_APPROVER_FIND_DTO = 'task/payment-scenarion-action-approver-find.dto',
}
